// extracted by mini-css-extract-plugin
export default {"card":"ReportsCard_card__umqe-","title":"ReportsCard_title__I63uj","description":"ReportsCard_description__QjI0k"};